import { faBoltLightning, faGem, faLock, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const FeaturesSection = () => {
  const features = [
    {
      icon: faUsers,
      title: 'Expert Team',
      description: 'Backed by a team of former immigration officers and legal professionals with more than a century of collective experience in UK immigration law and procedures.'
    },
    {
      icon: faLock,
      title: 'Secure & Confidential',
      description: 'Your personal information and documents are protected with enterprise-grade security measures and strict confidentiality protocols.'
    },
    {
      icon: faGem,
      title: 'Premium Service',
      description: 'Personalized attention with dedicated case managers who guide you through every step of the immigration process.'
    },
    {
      icon: faBoltLightning,
      title: 'Fast Processing',
      description: 'Optimized processes and expert document preparation ensure faster visa approvals and minimal processing delays.'
    }
  ];

  return (
    <div className="mb-16">
      <h2 className="text-3xl font-bold text-gray-900 text-center mb-12" data-aos="zoom-in">Why Choose All Global Consultancy Services?</h2>
      <div className="grid md:grid-cols-2 gap-8">
        {features.map((feature, index) => (
          <div key={index} data-aos="fade-right" className="flex items-start space-x-4 p-6 bg-blue-50 rounded-xl border border-blue-100">
            <div className="flex-shrink-0 w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center text-white text-xl">
              <FontAwesomeIcon icon={feature.icon}/>
            </div>
            <div>
              <h3 className="font-bold text-gray-900 text-lg mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturesSection;